import { render, staticRenderFns } from "./TheApp.vue?vue&type=template&id=497fc83a&scoped=true"
import script from "./TheApp.vue?vue&type=script&lang=ts"
export * from "./TheApp.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TheApp.vue?vue&type=style&index=0&id=497fc83a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./TheApp.vue?vue&type=style&index=1&id=497fc83a&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "497fc83a",
  null
  ,true
)

export default component.exports